//
// demo.js
// Theme module
//

// Vendors
import * as noUiSlider from "nouislider";
import "jquery-sortable";
import iro from "@jaames/iro";
import autosize from "autosize";

(function ($, waTheme) {

    $.ajaxSetup({cache: false});

    var DemoPanel = (function () {

        DemoPanel = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$panelButtons = that.$wrapper.find("button.l-demo-panel__buttons-item");
            that.$panelOffCanvas = that.$wrapper.find(".l-demo-panel__offcanvas");
            that.$panelForm = that.$wrapper.find('form');
            that.$panelFormReset = that.$wrapper.find(".js-themesettings-reset");
            that.$panelFormPreview = that.$wrapper.find(".js-themesettings-preview");
            that.$panelFormSubmit = that.$wrapper.find(".js-themesettings-save");
            that.$panelPlaceholder = that.$wrapper.find(".offcanvas-bg-loader");

            // OffCanvas Panel
            that.$panelOffCanvasAside = that.$panelOffCanvas.find(".l-demo-panel__offcanvas-aside");
            that.$panelOffCanvasContent = that.$panelOffCanvas.find(".l-demo-panel__offcanvas-content");
            that.$panelOffCanvasTabs = that.$panelOffCanvas.find(".l-demo-panel__offcanvas-content-tab");

            // OffCanvas Aside Navigation
            that.$panelOffCanvasAsideParents = that.$panelOffCanvasAside.find(".l-demo-panel__offcanvas-group-parent");
            that.$panelOffCanvasAsideGroups = that.$panelOffCanvasAside.find(".l-demo-panel__offcanvas-group");

            // OffCanvas Content Accordion
            that.$panelOffCanvasAccordionButton = that.$panelOffCanvasContent.find(".accordion-button");

            //
            // Settings
            //

            // ImageSelect
            that.$panelOffCanvasImageSelect = that.$panelOffCanvasContent.find(".l-demo-panel__option-image-select");

            // ImageUpload
            that.$panelOffCanvasImageUpload = that.$panelOffCanvasContent.find(".l-demo-panel__setting--image");

            // Sortable
            that.$panelOffCanvasSortable = that.$panelOffCanvasContent.find(".jq-sortable");
            that.$panelOffCanvasSortableItem = that.$panelOffCanvasSortable.find(".l-demo-panel__sortable-item");

            // Sortable Item Id && Title Editor
            that.$panelOffCanvasSortableItemMainProps = that.$panelOffCanvasSortableItem.find(".l-demo-panel__sortable_main_props");
            that.$panelOffCanvasSortableItemMainPropsText = that.$panelOffCanvasSortableItem.find(".l-demo-panel__sortable_main_props_text");

            // Sortable Enable Checkbox
            // that.$panelOffCanvasSortableEnableCheckbox = that.$panelOffCanvasSortableItem.find(".l-demo-panel__sortable-enable");

            // Sortable Props Fields
            that.$panelOffCanvasSortableItemPropsText = that.$panelOffCanvasSortable.find(".l-demo-panel__sortable_props_text");
            that.$panelOffCanvasSortableItemPropsCheckbox = that.$panelOffCanvasSortable.find(".l-demo-panel__sortable_props_checkbox");
            that.$panelOffCanvasSortableItemPropsSelect = that.$panelOffCanvasSortable.find(".l-demo-panel__sortable_props_select");
            that.$panelOffCanvasSortableItemPropsIconSelect = that.$panelOffCanvasSortable.find(".l-demo-panel__sortable_props_checkbox");

            // Sortable Add && Delete User Item
            that.$panelOffCanvasSortableItemUserAddButton = that.$panelOffCanvasContent.find(".js-sortable-user-add");

            // PromosList Select
            that.$panelOffCanvasPromosListSelect = that.$panelOffCanvasContent.find(".l-demo-panel__option-promo-select");

            // VARS
            that.activeClass = "is-active";
            that.disabledClass = "is-disabled";
            that.saveUrl = `${window.waTheme.backend_url}site/?module=design&theme=${window.waTheme.theme.id}&action=themeSettings`;

            // DYNAMIC VARS

            // INIT
            that.initClass();
        };

        DemoPanel.prototype.initClass = function () {
            var that = this;

            // Init Sortable
            $(".jq-sortable").each(function () {
                $(this).sortable({
                    handle: ".l-demo-panel__sortable-item__handle",
                    bodyClass: "jq-sortable-dragging",
                    draggedClass: "jq-sortable-dragged",
                    placeholderClass: "jq-sortable-placeholder",
                    placeholder: `<li class="jq-sortable-placeholder"></li>`,
                    exclude: ".js-not-draggable",
                    nested: false,
                    onDrop: function ($item, container) {
                        $item.removeClass(container.group.options.draggedClass).removeAttr("style")
                        $("body").removeClass(container.group.options.bodyClass)

                        var $input = $item.parents(".l-demo-panel__option").children("input[type='hidden']");
                        var $items = $item.parents(".jq-sortable").find(".l-demo-panel__sortable-item");
                        that.updateSortable($input, $items);
                    },
                });
            });

            // Init @jaames/iro (color picker)
            let pickers = document.querySelectorAll(".js-color-picker");
            pickers.forEach((picker) => {
                let colorPicker = new iro.ColorPicker(picker, {
                    width: 100,
                    color: "#ffffff",
                });

                let colorInput = picker.nextSibling;

                colorPicker.on(["color:change"], function (color) {
                    colorInput.value = color.hexString;
                });

                colorInput.addEventListener('change', function () {
                    if (this.value) {
                        colorPicker.color.hexString = this.value;
                    }
                });
            });

            // Init NoUiSlider
            let sliders = document.querySelectorAll("[data-nouislider]");
            sliders.forEach((slider) => {

                let input = slider.previousElementSibling;
                let values = slider.getAttribute("data-nouislider-pips-values").split(",");

                noUiSlider.create(slider, {
                    range: {
                        'min': parseInt(slider.getAttribute("data-nouislider-min")),
                        'max': parseInt(slider.getAttribute("data-nouislider-max"))
                    },
                    start: parseInt(slider.getAttribute("data-nouislider-start")),
                    step: 1,
                    pips: {
                        mode: 'steps',
                        // values: slider.getAttribute("data-nouislider-pips-values"),
                        density: 3,
                        stepped: true,
                        format: {
                            to: function (value) {
                                return values[value - 1];
                            },
                            // from: function (value) {
                            //     return Number(value.replace(',-', ''));
                            // }
                        }
                    },
                    format: {
                        // 'to' the formatted value. Receives a number.
                        to: function (value) {
                            return value;
                        },
                        // 'from' the formatted value.
                        // Receives a string, should return a number.
                        from: function (value) {
                            return parseFloat(value);
                        }
                    }
                });

                slider.noUiSlider.on('change.one', function (number) {
                    let data = JSON.parse(input.value);

                    data["value"] = number[0];
                    input.value = JSON.stringify(data);
                });
            });

            // Init Dropzone
            let dropzones = document.querySelectorAll("[data-dropzone]");
            dropzones.forEach((dropzone) => {

                let input = dropzone.querySelectorAll("input[type=file]")[0];

                function changeTitle(filename) {
                    let title = dropzone.querySelectorAll(".l-demo-panel__dropzone-title")[0];
                    title.innerHTML = `${filename} ${window.waTheme.locale["uploaded"].toLowerCase()}`;
                }

                input.addEventListener('change', (event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    changeTitle(input.files[0].name);
                });

                dropzone.addEventListener('dragover', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    event.dataTransfer.dropEffect = 'copy';
                });

                dropzone.addEventListener('dragover', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    event.dataTransfer.dropEffect = 'copy';
                });

                dropzone.addEventListener('drop', (event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    input.files = event.dataTransfer.files;
                    changeTitle(event.dataTransfer.files[0].name);
                });
            });

            // Init Autosize
            autosize($('textarea'));

            // Open OffCanvas
            that.$panelButtons.on("click", function () {

                let tab = $(this).data("tab"),
                    $tab = that.$wrapper.find(`#${tab}-tab`),
                    is_shown = that.$panelOffCanvas.hasClass("show");

                // Toggle Tabs
                that.$panelOffCanvasTabs.removeClass("active");
                $tab.addClass("active");

                // Show OffCanvas
                if (!is_shown) {
                    that.$panelOffCanvas.offcanvas("show");
                }

                // let offcanvas_class = $(this).data("offcanvas"),
                //     $offcanvas = that.$wrapper.find(`#${offcanvas_class}`),
                //     is_shown = $offcanvas.hasClass("show");
                //
                // // Hide OffCanvas
                // that.$panelOffCanvas.offcanvas("hide");
                //


                // Open group from cookie
                var activeGroupId = $.cookie("demo-panel-group") !== null ? $.cookie("demo-panel-group") : "common__design-tab";
                that.$panelOffCanvasAside.find(`#${activeGroupId}`).parent(".list-group-item").addClass(that.activeClass);
                that.$panelOffCanvasAside.find(`#${activeGroupId}`).click();
            });

            // Aside OffCanvas Navigation
            that.$panelOffCanvasAsideParents.on("click", function () {
                // return if active
                if ($(this).hasClass(that.activeClass)) {
                    return;
                }

                // Close active group
                that.$panelOffCanvasAsideParents.removeClass(that.activeClass);
                that.$panelOffCanvasAsideParents.parent(".list-group-item").removeClass(that.activeClass);

                // Open group
                $(this).parent(".list-group-item").addClass(that.activeClass);
                $(this).addClass(that.activeClass);

                // Open tab
                $(this).next(".l-demo-panel__offcanvas-group").click();

                // Save active group to cookie
                $.cookie("demo-panel-group", $(this).next(".l-demo-panel__offcanvas-group").attr("id"), {
                    expires: 30,
                    path: "/"
                });
            });

            // Save active group to cookie
            that.$panelOffCanvasAsideGroups.on("click", function () {
                $.cookie("demo-panel-group", $(this).attr("id"), {expires: 30, path: "/"});
            });

            // Save active accordion item to cookie
            that.$panelOffCanvasAccordionButton.on("click", function () {
                $.cookie("demo-panel-accordion", $(this).attr("aria-controls"), {expires: 30, path: "/"});
            });

            //
            // Home block actions
            //

            // Open offCanvas
            $(".js-edit-block:not(form)").on("click", function () {
                var id = $(this).parents(".b-home-item").data("id");
                $.cookie("demo-panel-group", `${id}-tab`, {expires: 30, path: "/"});
                that.$panelButtons.trigger("click");
            });

            //
            $(".js-set-visible").on("click", function () {
                var index = $(this).parents(".b-home-item").data("index"),
                    wrapper = that.$wrapper.find("#home__sort"),
                    item = wrapper.find(".jq-sortable").find(`li:nth-child(${index + 1})`);
                item.find(".js-sortable-item-enable").click();
            });

            // Copy props
            // $(".js-copy-props").on("click", function () {
            //     var item = $(this).parents(".b-home-item"),
            //         propsElement = item.find("[data-props]")[0],
            //         props = propsElement.getAttribute("data-props"),
            //         propsOffcanvas = $(".b-home-props-offcanvas");
            //
            //     // console.log(props.getAttribute("data-props"));
            //
            //     propsOffcanvas.offcanvas("show");
            //     propsOffcanvas.find(".b-home-props-offcanvas__json").text(props);
            // });

            //
            // Settings
            //

            // ImageSelect
            that.$panelOffCanvasImageSelect.on("click", function () {
                if ($(this).hasClass(that.activeClass)) {
                    return;
                }
                if ($(this).hasClass(that.disabledClass)) {
                    return;
                }
                $(this).parents(".l-demo-panel__option").find(".l-demo-panel__option-image-select").removeClass(that.activeClass);
                $(this).addClass(that.activeClass);

                let image = $(this).find("input").val();
                $(this).parents(".l-demo-panel__option").find("input[type='hidden']").val(image);
            });

            that.$panelOffCanvasSortableItemMainPropsText.on("change, keyup", function () {
                let prop = $(this).data("main-prop");
                $(this).parents(".l-demo-panel__sortable-item").data(prop, $(this).val());

                let $input = $(this).parents(".l-demo-panel__option").children("input[type='hidden']");
                let $items = $(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item");
                that.updateSortable($input, $items);
            });

            // ImageUpload - Remove
            that.$panelOffCanvasImageUpload.on("click", "button", function () {
                $(this).parents(".l-demo-panel__option").find("input:hidden").val("");
                $(this).parents(".l-demo-panel__option-image-upload").addClass("d-none");
            });

            // PromosList add to text input
            that.$panelOffCanvasPromosListSelect.on("click", function () {
                var $option = $(this).parents(".l-demo-panel__option"),
                    $items = $option.find(".list-group-item"),
                    $input = $option.find("input:text"),
                    promo_id = $(this).parents(".list-group-item").data("promo-id"),
                    single = !!$(this).parents(".l-demo-panel__setting").hasClass("l-demo-panel__setting--promoslist-single"),
                    promos_array = [];

                $items.each(function () {
                    let input = $(this).find("input:checkbox");

                    // uncheck if single
                    if (single === true && $(this).data("promo-id") !== promo_id) {
                        input.attr("checked", false);
                    }

                    //
                    if (input.attr("checked") !== undefined) {
                        let promo_id = $(this).data("promo-id");
                        promos_array.push(promo_id);
                    }
                });

                $input.val(promos_array.toString());
            });

            // Icon Select
            $(document).on("click", ".js-select-icon", function () {
                let icon = $(this).data("icon");
                let svg = $(this).html();

                // Для сортируемых списков
                if ($(this).parents(".l-demo-panel__sortable_props_iconselect")) {
                    let key = $(this).parents(".l-demo-panel__sortable_props_iconselect").data("key");
                    let props = $(this).parents(".l-demo-panel__sortable-item").data("props");

                    props[key]["value"] = icon;

                    $(this).parents(".l-demo-panel__sortable-item").find(".js-selected-icon").html(svg);
                    $(this).parents(".l-demo-panel__sortable-item").data("props", props);

                    let $input = $(this).parents(".l-demo-panel__option").children("input[type='hidden']");
                    let $items = $(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item");
                    that.updateSortable($input, $items);
                } else {
                    // Для обычный настройки
                    $(this).parents(".l-demo-panel__option").find(".js-selected-icon").html(svg);
                    $(this).parents(".l-demo-panel__option").find("input:hidden").val(icon);
                }
            });

            $(document).on("click", ".js-change-category", function () {
                if ($(this).hasClass("active")) {
                    return;
                }

                let category = $(this).data("category");

                //
                $(this).parents(".dropdown-menu").find(".list-group-item").removeClass("active");
                $(this).parent(".list-group-item").addClass("active");

                // $(this).parents(".list-group").addClass("placeholder-glow");
                // $(this).parents(".list-group").find(".list-group-item > .btn").addClass("placeholder").attr("tabindex","-1");

                $(this).parents(".dropdown-menu").find(".js-select-icon").addClass("placeholder-glow");
                $(this).parents(".dropdown-menu").find(".js-select-icon > .icon").addClass("placeholder");
                //

                $.get(window.waTheme.search_url, {iconSet: "true", "is_ajax": "true", set: category})
                    .done(html => {

                        let $html = $("<div></div>").html(html);
                        let $icon_set = $html.find(".b-iconset");

                        if ($icon_set.length) {
                            $(this).parents(".dropdown-menu").find(".icons").html($icon_set);
                        } else {
                            console.warn("Ошибка подключения файла с иконками");
                        }
                        // $(this).parents(".list-group").removeClass("placeholder-glow");
                        // $(this).parents(".list-group").find(".list-group-item > .btn").removeClass("placeholder");
                    });

            });

            // Sortable Item Enable Checkbox
            $(document).on("change", ".js-sortable-item-enable", function () {
                let itemEnable = $(this).parents(".l-demo-panel__sortable-item").data("enable") !== true;
                $(this).parents(".l-demo-panel__sortable-item").data("enable", itemEnable);

                let $input = $(this).parents(".l-demo-panel__option").children("input[type='hidden']");
                let $items = $(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item");

                that.updateSortable($input, $items);
            });

            // Sortable Item Id && Title
            that.$panelOffCanvasSortableItemMainProps.on("change, keyup", function () {
                let index = $(this).data("index");
                let props = $(this).parents(".l-demo-panel__sortable-item").data("props");

                props[index]["value"] = $(this).val();
                $(this).parents(".l-demo-panel__sortable-item").data("props", props);

                let $input = $(this).parents(".l-demo-panel__option").children("input[type='hidden']");
                let $items = $(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item");
                that.updateSortable($input, $items);
            });

            //
            // Sortable Item Props
            //

            // Sortable Item Prop Text
            that.$panelOffCanvasSortableItemPropsText.on("change, keyup", function () {
                let key = $(this).data("key");
                let props = $(this).parents(".l-demo-panel__sortable-item").data("props");

                props[key]["value"] = $(this).val();
                $(this).parents(".l-demo-panel__sortable-item").data("props", props);

                let $input = $(this).parents(".l-demo-panel__option").children("input[type='hidden']");
                let $items = $(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item");
                that.updateSortable($input, $items);
            });

            // Sortable Item Prop Checkbox
            that.$panelOffCanvasSortableItemPropsCheckbox.on("change", function () {
                let key = $(this).data("key");
                let props = $(this).parents(".l-demo-panel__sortable-item").data("props");

                let itemEnable = $(this).data("enable") !== true;
                $(this).data("enable", itemEnable);

                props[key]["value"] = itemEnable;
                $(this).parents(".l-demo-panel__sortable-item").data("props", props);

                let $input = $(this).parents(".l-demo-panel__option").children("input[type='hidden']");
                let $items = $(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item");
                that.updateSortable($input, $items);
            });

            // Sortable Item Prop Select
            that.$panelOffCanvasSortableItemPropsSelect.on("change", function () {
                let key = $(this).data("key");
                let props = $(this).parents(".l-demo-panel__sortable-item").data("props");

                props[key]["value"]["value"] = $(this).val();

                $(this).parents(".l-demo-panel__sortable-item").data("props", props);
                //
                let $input = $(this).parents(".l-demo-panel__option").children("input[type='hidden']");
                let $items = $(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item");
                that.updateSortable($input, $items);
            });

            // Sortable Add User Item
            that.$panelOffCanvasSortableItemUserAddButton.on("click", function () {

                let $input = $(this).parents(".l-demo-panel__option").children("input[type='hidden']");
                let inputData = JSON.parse($input.val());
                let sort = parseInt($(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item").length + 1);

                inputData[0]["props"]["name"]["value"] = `Новый блок ${sort} (опции будут доступны после сохранения)`;
                if (inputData[0]["props"]["template"]) {inputData[0]["props"]["template"]["value"] = "";}

                // меняем edit на true, чтобы пользователь мог всё редактировать
                Object.keys(inputData[0]["props"]).forEach(key => {
                    inputData[0]["props"][key]["edit"] = true;
                });

                let data = {
                    app: "block",
                    enable: false,
                    props: JSON.stringify(inputData[0]["props"]),
                    remove: true,
                };

                $(this).parents(".l-demo-panel__option").find(".jq-sortable").append(`
                    <li class="l-demo-panel__sortable-item list-group-item bg-gray-100" data-enable="${data["enable"]}" data-app="${data["app"]}" data-remove="${data["remove"]}" data-props='${data["props"]}'>
                        <div class="l-demo-panel__sortable-content d-flex justify-content-between align-items-center">
                            <div class="l-demo-panel__sortable-item-controls-left d-flex align-items-center">
                                <span class="l-demo-panel__sortable-item__handle icon icon-lg lh-0 text-theme">
                                    ${window.waTheme.icons["grip-dots-vertical"]}
                                </span>
                                <span class="ms-3 fs-sm">${inputData[0]["props"]["name"]["value"]}</span>
                            </div>
                            <div class="l-demo-panel__sortable-item-controls-right d-flex align-items-center">
                                <div class="form-control-lg form-check form-switch">
                                    <input type="checkbox" class="form-check-input js-sortable-item-enable" value="1">
                                </div>
                                <button class="btn btn-dark-theme-link ms-3 fs-sm border-0 p-0 js-sortable-user-remove" type="button">
                                    <span class="text-muted">${window.waTheme.locale["remove_item"]}</span>
                                </button>
                            </div>
                       </div>
                    </li>
               `);

                let $items = $(this).parents(".l-demo-panel__option").find(".l-demo-panel__sortable-item");
                that.updateSortable($input, $items);
            });

            // Sortable Remove User Item
            $(document).on("click", ".js-sortable-user-remove", function () {

                let $option = $(this).parents(".l-demo-panel__option");
                let $input = $option.children("input[type='hidden']");
                let inputData = JSON.parse($input.val());

                // Не даем удалить последний элемент
                if (Object.keys(inputData).length === 1) {

                    let toastHTML =
                        `<div class="d-flex">
                            <div class="toast-body text-danger">
                                ${window.waTheme.locale["remove_last_item"]}
                            </div>
                        </div>`;

                    const toast = new window.waTheme.init.site.Toast({
                        html: toastHTML
                    });

                    return;
                }

                // var $input = $item.parents(".l-demo-panel__option").children("input[type='hidden']");
                // var $items = $item.parents(".jq-sortable").find(".l-demo-panel__sortable-item");
                // that.updateSortable($input, $items);

                // let index = parseInt($(this).parents(".l-demo-panel__sortable-item").index());
                $(this).parents(".l-demo-panel__sortable-item").remove();
                // delete inputData[index];

                var $items = $option.find(".l-demo-panel__sortable-item");
                that.updateSortable($input, $items);

                // $input.val(JSON.stringify(inputData));
            });

            // Reset preview settings
            that.$panelFormReset.on("click", function (event) {
                event.preventDefault();
                that.resetPreviewSettings($(this));
            });

            // Preview settings
            that.$panelFormPreview.on("click", function (event) {
                event.preventDefault();
                that.previewSettings($(this));
            });

            // Save settings
            that.$panelForm.on("submit", function (event) {
                event.preventDefault();
                that.saveSettings();
            });

            that.$panelFormSubmit.on("click", function (event) {
                event.preventDefault();
                that.$panelForm.trigger("submit");
            });

            // $(document).bind("keyup keydown", function(event){
            //     if(event.ctrlKey && event.which === 83){
            //         that.saveSettings();
            //     }
            // });
        }

        DemoPanel.prototype.updateSortable = function ($input, $items) {
            var that = this;

            console.log($items.length);

            var data = {};

            $items.each(function (index) {
                if ($.isEmptyObject($(this).data()) === false) {
                    data[index] = $(this).data();
                }
            });

            // for(let k in data) {
            //     console.log(k, data[k]);
            // }

            $input.val(JSON.stringify(data));
        }

        DemoPanel.prototype.resetPreviewSettings = function ($button) {
            var that = this,
                resetURL = window.waTheme.themesettings_app.reset_url;

            if (resetURL !== undefined) {

                $button.find(".spinner-border").removeClass("d-none");
                that.$panelPlaceholder.removeClass("d-none");
                // that.$panelOffCanvas.addClass("pe-none");

                $.ajax({
                    url: resetURL,
                    type: "POST",
                    data: new FormData(that.$panelForm[0]),
                    dataType: "json",
                    processData: false,
                    contentType: false
                }).done(function (request) {
                    console.log(request);
                    location.reload();
                });
                return false;
            }
        }

        DemoPanel.prototype.previewSettings = function ($button) {
            var that = this,
                previewURL = window.waTheme.themesettings_app.default_url;

            if (previewURL !== undefined) {

                $button.find(".spinner-border").removeClass("d-none");
                that.$panelPlaceholder.removeClass("d-none");
                // that.$panelOffCanvas.addClass("pe-none");

                $.ajax({
                    url: previewURL,
                    type: "POST",
                    data: new FormData(that.$panelForm[0]),
                    dataType: "json",
                    processData: false,
                    contentType: false
                }).done(function (request) {
                    console.log(request);
                    location.reload();
                });

                return false;
            }
        }

        DemoPanel.prototype.saveSettings = function () {
            var that = this,
                saveURL = window.waTheme.themesettings_app !== undefined ? window.waTheme.themesettings_app.save_url : that.saveUrl;

            that.$panelFormSubmit.find(".spinner-border").removeClass("d-none");
            that.$panelPlaceholder.removeClass("d-none");
            // that.$panelOffCanvas.addClass("pe-none");

            $.ajax({
                url: saveURL,
                type: "POST",
                data: new FormData(that.$panelForm[0]),
                dataType: "json",
                processData: false,
                contentType: false
            }).done(function (request) {
                console.log(request);
                location.reload();
            });

            return false;
        }

        return DemoPanel;

    })();

    waTheme.init.site.DemoPanel = DemoPanel;

    if ($(".l-demo-panel").length) {
        new window.waTheme.init.site.DemoPanel({
            $wrapper: $(".l-demo-panel"),
        });
    }

})(jQuery, window.waTheme);
